//
// Image.js
// commons
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "../../moduleBuilder";
import ClosetObject from "../../ClosetObject";
import "../../lib";
import "./ImageOrigin";
import "./ImageFormat";

var Image = createModule("commons::Image", [], ClosetObject, [
    {
        UPDATED: 10016,
    },
    ,
    ,
    ,
    {
        getOriginPath: [7],
        getSize: [13],
        getOrigin: [4],
        getOriginFormat: [4],
        getTextureID: [3],
        getLocalPath: [7],
    },
    ,
    ,
]);
export default Image;
